<p-toast></p-toast>
<div class="tecGym-component training-session-attd">
    <p-dialog style="font-weight: 600;" [header]='setLabel("trainingSessionsHeaderLabel")' (onHide)="hideModal()"
        [(visible)]="trainingSessionsDialog" class="dialogPop">
        <form #TrainingSessionsDialogForm="ngForm" style="width: 320px; text-align: inherit;">
            <div class="payout-main-wrapper" *ngIf="presentClicked">
                <div class="payout-fields">
                    <span class="label">{{setLabel("performance:Label")}} </span>
                    <p-dropdown pInputText [options]="memberPerformanceArray"
                        [placeholder]='setLabel("selectPlaceholderLabel")' appendTo="body" name="memberPerformance"
                        [showClear]="true" optionLabel="name1" optionValue="code1" [(ngModel)]="memberPerformance"
                        #name="ngModel">
                    </p-dropdown>
                </div>
                <div class="payout-fields">
                    <span class="label">{{setLabel("exerciseType:Label")}} </span>
                    <p-multiSelect pInputText [placeholder]='setLabel("selectPlaceholderLabel")' appendTo="body"
                        [options]="excerciseOptions" [(ngModel)]="selectedexcerciseOptions" optionLabel="name2"
                        optionValue="code2" name="selectedexcerciseOptions"></p-multiSelect>
                </div>
                <div class="payout-fields" style="margin-top: 20px;align-items: center;">
                    <button class="p-g-6" type="button" pButton (click)="markPresent()"
                        [label]='setLabel("presentLabel")' style="width:100%; background-color: green;"></button>
                </div>
            </div>
            <div class="payout-main-wrapper">
                <div class="payout-fields" *ngIf="rescheduleClicked" style="display: flex; flex-direction: column; ">
                    <span class="label">{{setLabel("selectDate:Label")}} </span>
                    <p-calendar [yearNavigator]="true" appendTo="body" yearRange="1950:2040" [monthNavigator]="true"
                        [(ngModel)]="selectedDate" [placeholder]='setLabel("rescheduleDatePlaceholderLabel")'
                        name="createdDate" [inline]="false" dateFormat="dd/mm/yy" [showIcon]="true">
                    </p-calendar>
                </div>
                <div class="payout-fields" *ngIf="rescheduleClicked"
                    style="margin-top: 20px;display: flex; justify-content: center;">
                    <button type="button" pButton (click)="rescheduleSession()"
                        [label]='setLabel("rescheduleLabel")'
                        style="width:100%; margin-right: 10px; background-color: rgb(80, 120, 252);"></button>
                </div>
            </div>
        </form>
    </p-dialog>
</div>